import { useEffect, useState } from "react";

const LimitedStockBanner = () => {
  const [stockLeft, setStockLeft] = useState(null);

  useEffect(() => {
    const storedStock = localStorage.getItem("limitedStock");

    if (storedStock) {
      // On refresh, reduce by 1 but not below 1
      const newStock = Math.max(1, parseInt(storedStock) - 1);
      localStorage.setItem("limitedStock", newStock);
      setStockLeft(newStock);
    } else {
      // First time load: set a random number from 2 to 10
      const initialStock = Math.floor(Math.random() * 9) + 2; // 2 to 10
      localStorage.setItem("limitedStock", initialStock);
      setStockLeft(initialStock);
    }
  }, []);

  return stockLeft ? (
    <div className="limited-stock-banner">
      🎉 Hurry! Only <strong>{stockLeft}</strong> left in stock!
    </div>
  ) : null;
};

export default LimitedStockBanner;
